// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/MoscowSansRegular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

@font-face {
  font-family: 'MoscowSans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

#codd-monitoring-widget-root {
  display: flex;
  flex-direction: column;
}

body {
  font-family: 'MoscowSans';

  * {
    font-family: 'MoscowSans';
  }
}

html,
body,
#codd-monitoring-widget-root,
.App {
  width: 100%;
  height: 100%;
}

* {
  box-sizing: border-box;
  font-weight: 400;

  margin: 0;
  padding: 0;
}

.icon:not(.icon-disabled) {
  cursor: pointer;
}

.BreadcrumbRouterLink {
  text-decoration: none;
}

.highcharts-credits,
.hidden {
  display: none;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.hide-scrollbar {
  /*FireFox*/
  scrollbar-width: none;
  /*IE10+*/
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.hide-scrollbar::-webkit-scrollbar {
  /*Chrome, Safari, Edge*/
  display: none;
}

.tooltipContainer {
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,yBAAyB;EACzB,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;;EAEzB;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;;EAEhB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;EAClD,iBAAiB,EAAE;gFAC2D;AAChF;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,QAAQ;EACR,4CAA4C;AAC9C;AACA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kCAA0B;UAA1B,0BAA0B;AAC5B","sourcesContent":["body {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@font-face {\n  font-family: 'MoscowSans';\n  src: url(assets/fonts/MoscowSansRegular.otf) format('truetype');\n}\n\n#codd-monitoring-widget-root {\n  display: flex;\n  flex-direction: column;\n}\n\nbody {\n  font-family: 'MoscowSans';\n\n  * {\n    font-family: 'MoscowSans';\n  }\n}\n\nhtml,\nbody,\n#codd-monitoring-widget-root,\n.App {\n  width: 100%;\n  height: 100%;\n}\n\n* {\n  box-sizing: border-box;\n  font-weight: 400;\n\n  margin: 0;\n  padding: 0;\n}\n\n.icon:not(.icon-disabled) {\n  cursor: pointer;\n}\n\n.BreadcrumbRouterLink {\n  text-decoration: none;\n}\n\n.highcharts-credits,\n.hidden {\n  display: none;\n}\n\n.noselect {\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}\n\n.hide-scrollbar {\n  /*FireFox*/\n  scrollbar-width: none;\n  /*IE10+*/\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.hide-scrollbar::-webkit-scrollbar {\n  /*Chrome, Safari, Edge*/\n  display: none;\n}\n\n.tooltipContainer {\n  backdrop-filter: blur(6px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
